"use client";
import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuCheckboxItem, DropdownMenuSeparator, DropdownMenuLabel } from './dropdown-menu';
import { FreeButton } from './freeui-button';

export interface FreeMenuProps {
  label?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  options: string[] | React.ReactNode;
  plain?: boolean;
  defaultValue?: string;
  disabled?: boolean;
  trigger?: React.ReactElement;
  className?: string;
}
export function FreeMenu({ label, value, onValueChange, options, plain, defaultValue, disabled, trigger, className }: FreeMenuProps) {
  const [local, setLocal] = React.useState(defaultValue ?? (Array.isArray(options) && typeof options[0] === 'string' ? options[0] : 'Select'));
  const selected = value ?? local;
  return <DropdownMenu><DropdownMenuTrigger asChild>{trigger || <FreeButton size="md" plain={plain} disabled={disabled} className={className}>{label ?? selected}<ChevronDown size={12} /></FreeButton>}</DropdownMenuTrigger>
    <DropdownMenuContent align="start">{Array.isArray(options) && options.every(v => typeof v === 'string') ? options.map(option => <DropdownMenuCheckboxItem key={option} checked={selected === option} onSelect={() => { if (value === undefined) setLocal(option); onValueChange?.(option); }}>{option}</DropdownMenuCheckboxItem>) : options}</DropdownMenuContent>
  </DropdownMenu>;
}
export const FreeMenuItem = DropdownMenuItem;
export const FreeMenuCheckboxItem = DropdownMenuCheckboxItem;
export const FreeMenuSeparator = DropdownMenuSeparator;
export const FreeMenuLabel = DropdownMenuLabel;
